import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

import { INPUT_CLASS, SUBMIT_CLASS, ERROR_CLASS } from "../Auth/authStyles";
import { SERVERURL } from "../../ServerUrl";

const HEADING = "Contact us";
const SUBCOPY =
  "If you have any questions or would like to know more about us, please contact us";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  message: Yup.string().required("Message is required"),
});

const ContactForm = () => {
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(`${SERVERURL}/api/v1/contact`, values);
      if (response.data.success === true) {
        Swal.fire({
          icon: "success",
          title: "Message Sent",
          text: response.data.message,
        });
        resetForm();
      } else {
        Swal.fire({
          icon: "error",
          title: "Message could not Sent",
          text: response.data.message,
        });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops!", text: "An error occured." });
    }
  };

  return (
    <div className="w-full bg-white relative overflow-hidden">
      <div className="relative z-10 max-w-xl mx-auto px-4 md:px-10 pt-4 pb-10 md:pt-5 md:pb-16">
        <div className="rounded-3xl border border-black/10 bg-white p-3 md:p-4 shadow-[0_40px_80px_-32px_rgba(27,10,68,0.22)]">
          <div className="flex flex-col !flex-nowrap !justify-center px-4 py-8 md:px-10 md:py-10">
            <h1 className="font-headline font-bold tracking-tight text-[#111113] text-[clamp(1.5rem,2.4vw,1.9rem)] leading-[1.12] m-0">
              {HEADING}
            </h1>

            <p className="font-body text-[13px] text-[#4a4753] mt-2 mb-0">
              {SUBCOPY}
            </p>

            <Formik
              initialValues={{ name: "", email: "", message: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="flex flex-col !flex-nowrap gap-2.5 mt-5">
                  <div>
                    <Field
                      name="name"
                      placeholder="Your name"
                      className={INPUT_CLASS}
                    />
                    <ErrorMessage
                      name="name"
                      component="p"
                      className={ERROR_CLASS}
                    />
                  </div>

                  <div>
                    <Field
                      name="email"
                      type="email"
                      placeholder="Your email"
                      className={INPUT_CLASS}
                    />
                    <ErrorMessage
                      name="email"
                      component="p"
                      className={ERROR_CLASS}
                    />
                  </div>

                  <div>
                    <Field
                      name="message"
                      as="textarea"
                      rows={4}
                      placeholder="Your message"
                      className={`${INPUT_CLASS} resize-none`}
                    />
                    <ErrorMessage
                      name="message"
                      component="p"
                      className={ERROR_CLASS}
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`${SUBMIT_CLASS} !py-3 mt-2 disabled:opacity-60 disabled:cursor-not-allowed`}
                  >
                    <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">
                      {isSubmitting ? "Sending" : "Send message"}
                    </span>
                    <span className="material-symbols-outlined text-[18px] group-hover:animate-arrow-slide">
                      arrow_forward
                    </span>
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactForm;
